export default "__VITE_ASSET__BgRvfYZJ__"